import React, {useState, useEffect} from 'react'
import Company_select from './docs_company_select_3'
import Popup from '../middleware/popup'
import Load_poppup from './delivery_doc_load3'
import New_company from './New_company'
import './css/css.css'
import config_docs from './config_docs.json'
import province from './address/provinces.json'
import amphure from './address/amphures.json'
import tambons from './address/tambons.json'
import Edit_company from './Edit_company'
import { Job_media } from './docs_media'

import config from '../../config.json'
import PrintPDF from './pdfmake/pdf_main_2'

export default function Docs_deli(){
    const tokenString = sessionStorage.getItem('token');
    const userToken = JSON.parse(tokenString);
    const timestamp_now = new Date();
    const day = timestamp_now.getDate();
    const month = timestamp_now.getMonth() + 1;
    const year = timestamp_now.getFullYear();
    const ToDay = year + "-" + (Math.floor(month/10).toString()+month%10) + "-" + (Math.floor(day/10).toString()+day%10);
    const input_text_except = "[^'\x22;]+"

    const [load_old_data, set_load_old_data] = useState(false)
    const [load_id, set_load_id] = useState(0)

    const [Main_amo, set_Main_amo] = useState(1)

    const [pdf_url, set_pdf_url] = useState("")
    const [pdf_url_dw, set_pdf_url_dw] = useState("")

    const [add_ck, set_add_ck] = useState(false)
    const [update, set_update] = useState(0)
    const [place, set_place] = useState("")
    const [place_edit, set_place_edit] = useState("")
    const [json_pdf, set_json_pdf] = useState({
        number: "00000000",
        UHQ: "UHQ00000",
        po: "",
        product_number: "",
        company: "",
        place: "",
        name: "",
        tellnum: "",
        mail: "",
        deli_date: [day, month, year],
        headname: "",
        SMPP: false,
        KMMS: false
    })

    const [change_detail, set_change_detail] = useState(0)

    const [job_pdf_detail, set_job_pdf_detail] = useState(
        [
            {
                id: 1,
                name: "",
                head: false,
                amo: 0,
                unit: ""
            }
        ]
    )

    const [cust_id, set_cust_id] = useState(0)

    useEffect(() => {
        if(add_ck)
            update_obj_state({place: place_edit})
        else
            update_obj_state({place: place})
        const interval_num = setInterval(() => {
            if(!load_old_data)
                load_number()
        }, 5000)
        return () => {clearInterval(interval_num)}
    }, [update])

    const load_number = () => {
        const url = config.api_url+"/doc/get.php?mode=22&token="+userToken
        //console.log(url)
        fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
        .then((response) => response.json())
        .then((data) => {
            update_obj_state({number: data.number})
           // set_load_num(true)
        });
    }

    const job_main = () => {
        return(
            <>
                <div style={{marginBottom: "10px"}}>
                        <label>จำนวนประเภทสื่อ</label>
                        <input style={{width: "50px"}} type={"number"} min={1} value={Main_amo} onChange={(e) => {
                            set_Main_amo( (e.target.value.length == 0 || parseInt(e.target.value) <= 0) ? 1 : parseInt(e.target.value));
                            var job_pdf_detail_old = [...job_pdf_detail];
                            while(job_pdf_detail_old.length < parseInt(e.target.value))
                                job_pdf_detail_old.push([{
                                    id: 0,
                                    name: "",
                                    head: true,
                                    amo: 0,
                                    unit: ""
                                },{
                                    id: 1,
                                    name: "",
                                    head: false,
                                    amo: 1,
                                    unit: ""
                                }])
                            while(job_pdf_detail_old.length > parseInt(e.target.value))
                                job_pdf_detail_old.pop()
                            set_job_pdf_detail(job_pdf_detail_old);
                            set_change_detail(old => old+1)
                        }}/>
                    </div>
                <div className='doc_job_detail'>
                    {
                            [...Array(Main_amo)].map((e, v) => {
                                return(
                                    <Job_media number={v+1} return={val => update_job_pdf_detail(val, v)} data={job_pdf_detail[v]} load_id={load_id} old_data={load_old_data}/>
                                )
                        })
                    }
                </div>
            </>
        )
    }

    const update_obj_state = (val) => {
        set_json_pdf(old => ({
            ...old,
            ...val
        }))
    }
    const update_job_pdf_detail = (data, index) => {
        var job_pdf_detail_old = [...job_pdf_detail];
        job_pdf_detail_old[index] = data;
        set_job_pdf_detail(prev => job_pdf_detail_old);
    }

    const fontInColor = "#7f7f7f"

    function edit_form(){
        return(
            <form>
                <label style={{fontSize: "18pt", gridColumn: "1/4", color: fontInColor}}>
                    ใบส่งของชั่วคราว
                </label>
                <label style={{userSelect: "none", color: fontInColor}}>
                    <input disabled={false} type="checkbox" checked={json_pdf.KMMS} onChange={ e => {
                        update_obj_state({KMMS: e.target.checked});
                        set_update(old => old+1)
                    }}/>
                    (กระทำการแทน KMMS)
                </label>
                <label style={{userSelect: "none", color: fontInColor}}>
                    <input disabled={false} type="checkbox" checked={json_pdf.SMPP} onChange={ e => {
                        update_obj_state({SMPP: e.target.checked});
                        set_update(old => old+1)
                    }}/>
                    SMPP
                </label>
                <div></div>

                <label className='doc_border' style={{height: "fit-content"}}>
                    <p style={{color: fontInColor, margin: "0"}}>
                        วันที่
                        <input style={{marginLeft: "5px"}} type="date" value={ToDay} disabled={true}/>
                    </p>
                </label>
                <label className='doc_border' style={{height: "fit-content"}}>
                    <p style={{color: fontInColor, margin: "0"}}>
                        เลขที่ :
                        <input style={{width: "85px", marginLeft: "5px"}} type="text"
                            Value={json_pdf.number}
                            disabled={true}
                        />    
                    </p>
                </label>
                <label className='doc_border' style={{height: "fit-content"}}>
                    <p style={{color: fontInColor, margin: "0"}}>
                        UHQ :
                        <input disabled={false} style={{width: "80px", marginLeft: "5px"}} type="text"
                            value={json_pdf.UHQ}
                            onChange={ e => update_obj_state({UHQ: e.target.value})}
                        />
                    </p>    
                </label>

                <input id="mediaName" disabled={false} type="text" placeholder='ชื่อสื่อ' style={{padding: "5px", gridColumn: "1/4"}} required pattern={input_text_except}
                    value={json_pdf.headname}
                    onChange={ e => update_obj_state({headname: e.target.value})}
                />

                <input type={"text"} placeholder='รหัสสินค้า'
                    value={json_pdf.product_number}
                    onChange={ e => update_obj_state({product_number: e.target.value})}
                />

                <input type={"text"} placeholder='เลขที่ PO'
                    value={json_pdf.po}
                    onChange={ e => update_obj_state({po: e.target.value})}
                />

                <div></div>

                <Company_select load_data={load_old_data} chg_det={change_detail} send={json_pdf.company} return={val => {
                    update_obj_state({company: val.name});
                    load_address(val.id)
                    set_cust_id(val.id)
                }}/>
                <label style={{userSelect: "none", color: fontInColor}}>
                    <input disabled={false} type="checkbox" onChange={ e => {
                        set_add_ck(e.target.checked);
                        set_update(old => old+1)
                    }}/>
                    แก้ไข/เพิ่มเติมที่อยู่
                </label>

                {/* <textarea disabled={true} style={{gridColumn: "1/4"}} className='doc_textarea' rows="4" cols={100}
                    value={place}
                /> */}
                <input style={{gridColumn: "1/4"}} disabled={true} value={place} placeholder='ที่อยู่'/>



                <Address_edit add_ck={add_ck} chg_det={change_detail} text_address={val => {set_place_edit(val); set_update(old => old+1)}}/>
                <input disabled={false} type="text" placeholder='ติดต่อ' style={{padding: "5px"}} required pattern={input_text_except}
                    value={json_pdf.name}
                    onChange={ e => update_obj_state({name: e.target.value})}
                />
                <input disabled={false} type="text" placeholder='โทร' style={{padding: "5px"}} required pattern={input_text_except}
                    value={json_pdf.tellnum}
                    onChange={ e => update_obj_state({tellnum: e.target.value})}
                />
                <div style={{gridColumn: "3/4", padding: "5px"}} className='doc_border'>
                    <label>
                        <span style={{fontSize: "12px", color: fontInColor}}>กำหนดส่ง</span>
                        <input style={{marginLeft: "5px", border: "none"}} disabled={false} type="date" value={(json_pdf.deli_date[2]+"-"+json_pdf.deli_date[1]+"-"+json_pdf.deli_date[0])}
                            onChange={ e => {
                                const date_split = e.target.value.split("-")
                                update_obj_state({deli_date: [date_split[2], date_split[1], date_split[0]]})
                            }}
                        />
                    </label>
                </div>

                <div style={{gridColumn: "3/4"}}></div>

                <div style={{gridColumn: "1/4"}}>
                    {job_main()}
                </div>

            </form>
        )
    }

    const btn_pdf = () => {


        return(
            <div style={{display: "flex", height: "100%", flexDirection: "column", margin: "auto"}}>
                <div className='btn_pdf'>
                    <button onClick={() => {
                        var job_pdf_merge = [];
                        for(const i in job_pdf_detail){
                            for(const j in job_pdf_detail[i])
                                job_pdf_merge.push(job_pdf_detail[i][j])
                        }
                        PrintPDF(json_pdf, [day, month, year], job_pdf_merge).then((data) => {
                            set_pdf_url(data[0])
                            set_pdf_url_dw(data[1])
                        })
                    }}>
                        Preview
                    </button>
                    <button onClick={() => {
                        set_json_pdf({
                            number: "00000000",
                            UHQ: "UHQ00000",
                            po: "",
                            product_number: "",
                            company: "",
                            place: "",
                            name: "",
                            tellnum: "",
                            mail: "",
                            deli_date: [day, month, year],
                            headname: "",
                            SMPP: false,
                            KMMS: false
                        })
                        load_number()
                        set_job_pdf_detail([
                            {
                                id: 1,
                                name: "",
                                head: false,
                                amo: 0,
                                unit: ""
                            }
                        ])
                        set_load_old_data(false)
                        //set_Main_amo(1)
                        set_place("")
                        set_load_id(0)

                        set_change_detail(old => old+1)
                        set_update(old => old+1)
                    }}>
                        New
                    </button>
                    <Popup btn_text="New Compa." fontSize="14px" width="800px" height="250px" turnOff={update}>
                        <New_company sended={() => set_update(old => old+1)}/>
                    </Popup>
                    <Popup btn_text="Edit Compa." fontSize="14px" width="500px" height="500px" turnOff={update}>
                        <Edit_company sended={() => set_update(old => old+1)}/>
                    </Popup>
                    <button onClick={() => {
                        //alert("เป็นตัวทดสอบ Save ไม่ได้")
                        if(!window.confirm("คุณต้องการที่จะบันทึกใช่หรือไม่")) return;
                        const json = {
                            mode: 3,
                            data: {
                                number: json_pdf.number,
                                date: ToDay,
                                cust_id: cust_id,
                                uhq: json_pdf.UHQ,
                                addre: json_pdf.place,
                                name: json_pdf.company,
                                head_name: json_pdf.headname,
                                contact: json_pdf.name,
                                tell: json_pdf.tellnum,
                                mail: json_pdf.mail,
                                KMMS: json_pdf.KMMS ? 1 : 0,
                                SMPP: json_pdf.SMPP ? 1 : 0,
                                PO: json_pdf.po,
                                product_number: json_pdf.product_number,
                                deli_date: json_pdf.deli_date[2]+"-"+json_pdf.deli_date[1]+"-"+json_pdf.deli_date[0],
                                media: job_pdf_detail,
                                token: userToken
                            },
                            token: userToken
                        }
                        //console.log(json);
                        save_pdf(json, load_old_data)
                    }}>Save</button>
                    <Popup btn_text="Load" width="500px" height="500px" turnOff={update}>
                        <Load_poppup return={(data) => 
                            {   
                                set_json_pdf(data.head);
                                set_place(data.head.place);
                                set_job_pdf_detail(data.media);
                                set_load_old_data(true);
                                set_load_id(parseInt(data.main_id))
                                set_Main_amo(parseInt(data.amount));
                                set_change_detail(old => old+1)
                            }
                        }
                        />
                    </Popup>
                    <a download={json_pdf.number} href={pdf_url_dw}
                        style={{pointerEvents: pdf_url_dw == "" ? "none" : "auto", userSelect: "none"}}
                    >
                        Download
                    </a>
                    <div style={{border: "none", textAlign: "center"}}>
                        <i class="fa fa-exclamation-circle tooltip" style={{margin: "auto", border: "none"}}>
                            <span class="tooltiptext">
                                This pdf made by pdfmaker and pdf-lib and pdf-lib is MIT License
                                    MIT License
                                    Copyright (c) 2019 Andrew Dillon
                                    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
                                    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
                                    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
                            </span>
                        </i>
                    </div>
                </div>
            </div>
        )
    }

    const load_address = (id) => {
        const url = config.api_url+"/doc/get.php?mode=1&id="+id+"&token="+userToken
        fetch(url, {
            method: "GET",
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
        })
        .then((response) => response.json())
        .then((data) => {
            set_place(data.address)
            set_update(old => old+1)
        });
    }        

    return(
        <div style={{padding: "2rem"}}>
            <h3>ใบส่งสินค้าชั่วคราว Delivery Note</h3>
            <div className='doc_grid'>
                <div className='doc_bg'>
                    {
                        edit_form()
                    }
                </div>
                <div>
                    {
                        btn_pdf()
                    }
                </div>
                <object data={pdf_url} type="application/pdf" width="100%" height="100%" download="www">
                    <p style={{textAlign: "center"}}>กด Preview เพื่อแสดง pdf</p>
                </object>
            </div>
        </div>
    )
}

export function Address_edit(props){
    const [provinceSelec, set_province] = useState("")
    const [amphureSelec, set_amphure] = useState("")
    const [tambonsSelec, set_tambons] = useState("")
    const [province_id, set_province_id] = useState(0)
    const [amphure_id, set_amphure_id] = useState(0)
    const [tambons_id, set_tambons_id] = useState(0)

    const [etc_add, set_etc_add] = useState("")

    const [addres_id, set_address_id] = useState("")
    const [moo_id, set_moo] = useState("")
    const [rd, set_rd] = useState("")
    const [zip_id, set_zip_id] = useState("")

    const [update, set_update] = useState(0)
    const [change_detail, set_change_detail] = useState(0)

    const input_text_except = "[^'\x22;]+"

    useEffect(() => {
        props.text_address(
            province_id != 1 ? `เลขที่ ${addres_id} หมู่ ${moo_id} ถนน ${rd}\nตำบล ${tambonsSelec} อำเภอ ${amphureSelec}\nจังหวัด ${provinceSelec} ${zip_id} \n${etc_add}`
            : `เลขที่ ${addres_id} หมู่ ${moo_id} ถนน ${rd}\n ${tambonsSelec} ${amphureSelec}\nจังหวัด ${provinceSelec} ${zip_id} \n${etc_add}`
        )
        if(props.chg_det != change_detail){
            set_province("")
            set_amphure("")
            set_tambons("")
            set_province_id(0)
            set_amphure_id(0)
            set_tambons_id(0)
            set_address_id("")
            set_moo("")
            set_rd("")
            set_zip_id("")
            set_etc_add("")

            set_change_detail(props.chg_det)
        }
    }, [update, props.chg_det])

    if(props.add_ck)
    return(
        <>
            <input type="text" placeholder='เลขที่' disabled={!props.add_ck} required pattern={input_text_except}
                value={addres_id}
                onChange={ e => {
                    set_address_id(e.target.value)
                    set_update(old => old+1)
                }}
            />
            <input type="text" placeholder='หมู่' disabled={!props.add_ck} required pattern={input_text_except}
                value={moo_id}
                onChange={ e => {
                    set_moo(e.target.value)
                    set_update(old => old+1)
                }}
            />
            <input type="text" placeholder='ถนน' style={{gridColumn: "3/4"}} disabled={!props.add_ck}  required pattern={input_text_except}
                value={rd}
                onChange={ e => {
                    set_rd(e.target.value)
                    set_update(old => old+1)
                }}
            />
            

            <select className='doc_select' disabled={!props.add_ck}  required
                value={province_id}
                onChange={e => {
                    set_province_id(e.target.value)
                    set_province(province.RECORDS.find(val => val.id == e.target.value).name_th)
                    set_update(old => old+1)
                }}
            >
                <option value={0}>--- จังหวัด ---</option>
                {
                    Object.entries(province.RECORDS).map((val, i) =>{
                        return(
                            <option value={val[1].id}>
                                {val[1].name_th}
                            </option>
                        )
                    })
                }
            </select>
            <select className='doc_select' disabled={!props.add_ck}  required
                onChange={e => {
                    set_amphure_id(e.target.value)
                    set_amphure(amphure.RECORDS.find(val => val.id == e.target.value).name_th)
                    set_update(old => old+1)
                }}
                value={amphure_id}
            >
                <option value={0}>{province_id != 1 ? "--- อำเภอ ---" : "--- เขต ---"}</option>
                {
                    Object.entries(amphure.RECORDS).map((val, i) =>{
                        if(provinceSelec != "")
                        if(val[1].province_id == province_id)
                        return(
                            <option value={val[1].id}>
                                {val[1].name_th}
                            </option>
                        )
                    })
                }
            </select>
            <select className='doc_select' disabled={!props.add_ck}  required
                onChange={e => {
                    set_tambons_id(e.target.value)
                    set_tambons(tambons.RECORDS.find(val => val.id == e.target.value).name_th)
                    set_update(old => old+1)
                }}
                value={tambons_id}
            >
                <option value={0}>{province_id != 1 ? "--- ตำบล ---" : "--- แขวง ---"}</option>
                {
                    Object.entries(tambons.RECORDS).map((val, i) =>{
                        if(amphureSelec != "")
                        if(val[1].amphure_id == amphure_id)
                        return(
                            <option value={val[1].id}>
                                {val[1].name_th}
                            </option>
                        )
                    })
                }
            </select>
            <input type="text" placeholder='รหัสไปรษณีย์' disabled={!props.add_ck}  required pattern={input_text_except}
                value={zip_id}
                onChange={ e => {
                    set_zip_id(e.target.value)
                    set_update(old => old+1)
                }}
            />

            <input type="text" placeholder='อื่นๆ เกี่ยวกับที่อยู่' style={{gridColumn: "1/4"}} disabled={!props.add_ck}  required pattern={input_text_except}
                value={etc_add}
                onChange={ e => {
                    set_etc_add(e.target.value)
                    set_update(old => old+1)
                }}
            />
        </>
    )
}

const Job_sub = (props) => {
    const [Job_sub_amo, set_Job_sub_amo] = useState(1)
    const [json_detail, set_json_detail] = useState([{
        id: 1,
        name: "",
        amo: 1,
        unit: 0
    }])
    const [update, set_update] = useState(0)
    const [change_detail, set_change_detail] = useState(0)
    const [sub_text, set_sub_text] = useState("")
    const [amo, set_amo] = useState("")
    const [unit, set_unit] = useState("")

    useEffect(() => {
        if(props.disabled){
            if(props.chg_det != change_detail){
                set_json_detail(props.job_detail)
                set_Job_sub_amo(props.job_detail.length)
                set_change_detail(props.chg_det)
                set_update(old => old+1)
                var sub_text = "", amount_text = "", unit_text = "";
                for(var i in props.job_detail){
                    sub_text +=  (props.job_detail[i].head) ? ":h:"+props.job_detail[i].name+"\n" : props.job_detail[i].name+"\n";
                    amount_text += props.job_detail[i].amo+"\n";
                    unit_text += props.job_detail[i].unit+"\n";
                }
                set_sub_text(sub_text)
                set_amo(amount_text)
                set_unit(unit_text)
            }
        }
        else{
            if(props.chg_det != change_detail){
                set_json_detail([{
                    id: 1,
                    name: "",
                    amo: 1,
                    unit: 0,
                }])
                set_Job_sub_amo(1)
                set_change_detail(props.chg_det)
                set_update(old => old+1)
            }
        }
    }, [update, props.chg_det])

    const text_detail = (text) => {
        const text_split = text.split("\n")
        var out = []
        var text_out = ""
        for(var i in text_split){
            out.push({
                id: parseInt(i)+1,
                name: (text_split[i].substring(0, 3) == ":h:") ? text_split[i].substring(3) : text_split[i],
                head: (text_split[i].substring(0, 3) == ":h:"),
                amo: "",
                unit: 0,
            })
            text_out += text_split[i]+"\n"
        }
        set_sub_text(text_out.slice(0, -1))
        set_json_detail(out)
        props.detailOut(text)
        props.rec(out)
    }
    const amount_detail = (text) => {
        const text_split = text.split("\n")
        var out = json_detail
        var text_out = ""
        for(var i in text_split){
            out[i].amo = parseInt(text_split[i])
            text_out += text_split[i]+"\n"
        }
        set_amo(text_out.slice(0, -1))
        set_json_detail(out)
        props.amountOut(text)
        props.rec(out)
    }
    const unit_detail = (text) => {
        const text_split = text.split("\n")
        var out = json_detail
        var text_out = ""
        for(var i in text_split){
            out[i].unit = text_split[i]
            text_out += text_split[i]+"\n"
        }
        set_unit(text_out.slice(0, -1))
        set_json_detail(out)
        props.unitOut(text)
        props.rec(out)
    }

    return(
        <div style={{display: "grid", gridTemplateColumns: "1fr 100px 100px", height: "500px"}}>
            <textarea style={{resize: "none", fontSize: "16px", borderRadius: "5px 0 0 5px", borderRightStyle: "none"}} rows={10} placeholder='รายการ' value={sub_text} onChange={(e) => text_detail(e.target.value)}/>
            <textarea style={{resize: "none", fontSize: "16px", borderRadius: "0"}} rows={10} placeholder='จำนวน' value={amo} onChange={e => amount_detail(e.target.value)}/>
            <textarea style={{resize: "none", fontSize: "16px", borderRadius: "0 5px 5px 0", borderLeftStyle: "none"}} rows={10} placeholder='หน่วย' value={unit} onChange={e => unit_detail(e.target.value)}/>
        </div>
    )
}

const Input_job_head = (props) => {
    const [text, set_text] = useState(props.val)
    const [update, set_update] = useState(0)

    useEffect(() => {
        props.return(text)
        if(update != props.update){
            set_text(props.val)
            set_update(props.update)
        }
    }, [text, props.update])

    return(
        <>
            <input disabled={false} style={{gridColumn: "1/4"}} type="text" placeholder={props.text}
                onChange={ e => {
                    set_text(e.target.value)
                }}
                value={text}
            />
        </>
    )
}

const save_pdf = (data_json, load_old_data) => {
    const url = config.api_url+ (!load_old_data ? "/doc/post.php" : "/doc/put.php")
    fetch(url, {
        method: (!load_old_data ? "POST" : "PUT"),
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data_json)
    })
    .then((response) => response.json())
    .then((data) => {
        if(data.status == 0)
            alert("สำเร็จ");
        window.location.reload()
    });
}